import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import GetChallengeNoteViewModel from "./ViewModels/GetChallengeNoteViewModel";
import QaQaiResponseContainer from "../QaView/QaQaiResponseContainer";
import QaiChallengeNote from "./QaiChallengeNote";


interface IQaiChallengeNotesProps {
    view: string
    notesViewModel: GetChallengeNoteViewModel[]
    getChallengeNotes: () => void;
}

export default function QaiChallengeNotes({ view, notesViewModel, getChallengeNotes }: IQaiChallengeNotesProps) {
    const [selectedNote, setSelectedNote] = useState<GetChallengeNoteViewModel | null>(null);

    return (
        <Grid
            height="60%"
            size={12}
            marginBottom={4}
            border="solid 1px rgb(192, 192, 192)"
            borderRadius="4px"
            sx={{ backgroundColor: '#f5f5f5', overflowY: 'auto' }}>
            <Grid padding={2} sx={{ overflowY: 'auto' }} maxHeight='100%'>
                {
                    notesViewModel.map(x =>
                        <>
                            <QaiChallengeNote view={view} note={x} setSelectedNote={setSelectedNote} />
                        </>
                    )
                }
            </Grid>
            {
                !!selectedNote &&
                <QaQaiResponseContainer
                    view={view}
                    open={!!selectedNote}
                    challenge={selectedNote!}
                    setChallenge={setSelectedNote}
                    getChallenges={getChallengeNotes} />
            }
        </Grid >
    )
}